import PageTitle from "../../components/PageTitle";
import Tx from "../../components/Tx";
import IconBtn from "../../components/IconBtn";
import React, {useEffect, useState} from "react";
import {api} from "../../maps/data.js";
import Table from '../../components/Table';
import Icn from '../../components/Icn';
import ShopperAddDialog from "../../components/dialogs/ShopperAddDialog";
import styled from "styled-components";
import {colors} from '../../maps/colors';
import useInfiniteScroll from 'react-infinite-scroll-hook';

const WrapperStyled = styled.div`
  padding: 20px;
`;

const ShoppersPage = () => {
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [shoppers, setShoppers] = useState([]);
    const [editShopper, setEditShopper] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [callingTheApi, setCallingTheApi] = useState(false);
    const [hasNextPage, setHasNextPage] = useState(true);


    const [sentryRef] = useInfiniteScroll({
        callingTheApi,
        hasNextPage,
        onLoadMore: getShoppers,
    });

    async function getShoppers() {
        setCallingTheApi(true);
        const response = await api({type: 'getShoppers', data: {page: currentPage, limit: 25}});
        setShoppers([...shoppers, ...response]);
        setCurrentPage(currentPage + 1);
        setCallingTheApi(false);
        if (response.length < 25) {
            setHasNextPage(false);
        }
    }

    const deleteShopperHandle = async (shopperItem) => {
        window.messageBox(`Are you sure delete ${shopperItem.name}?`, async (yesOrNo) => {
            if (yesOrNo) {
                await api({type: 'deleteShopper', data: {id: shopperItem._id}});
                setShoppers(shoppers.filter(shopper => shopper._id !== shopperItem._id));
            }
        }, true);
    };

    useEffect(() => {
        getShoppers();
    }, []);

    return (
        <WrapperStyled style={{ height: '100%', overflowY: 'scroll' }}>
            <PageTitle>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <Icn>shopper</Icn> <Tx>page.shoppers.title</Tx>
                    </div>
                    <IconBtn
                        style={{ zIndex: 2, border: `1px solid ${colors.WHITE}` }}
                        onClick={() => setIsOpenDialog(true)}
                    >
                        add
                    </IconBtn>
                </div>
            </PageTitle>
            <Table
                data={shoppers}
                headers={[
                    {label: <Tx>user.table.image</Tx>, field: 'imageUrl', type: 'profileImage'},
                    {label: <Tx>user.table.name</Tx>, field: 'name'},
                    {label: <Tx>user.table.email</Tx>, field: 'email'},
                    {label: <Tx>user.table.phone</Tx>, field: 'phone'}
                ]}
                actions={[
                    {
                        icon: 'edit',
                        action: item => {
                            setEditShopper(item);
                            setIsOpenDialog(true);
                        }
                    },
                    {
                        icon: 'delete',
                        action: item => {
                            deleteShopperHandle(item);
                        }
                    }
                ]}
            />
            <div style={{position: 'relative', top: '-25vh'}} ref={sentryRef}/>
            {isOpenDialog && (
                <ShopperAddDialog
                    open={isOpenDialog}
                    shopper={editShopper}
                    onClose={() => {
                        setEditShopper(null);
                        setIsOpenDialog(false);
                    }}
                    onNewShopper={(newShopper, isEdit) => {
                        let newShoppersList = [];
                        if (isEdit) {
                            newShoppersList = shoppers.map(shopper => {
                                if (shopper._id === newShopper._id) {
                                    return newShopper;
                                }
                                return shopper;
                            });
                        } else {
                            shoppers.unshift(newShopper);
                            newShoppersList = shoppers;
                        }
                        setShoppers(newShoppersList);
                        setEditShopper(null);
                        setIsOpenDialog(false);
                    }}
                />
            )}
        </WrapperStyled>
    );
};

export default ShoppersPage;

